import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import { useCallback, useEffect, useState } from 'react';
import useMountedState from 'react-use/lib/useMountedState';
import { isLocalhostEnvironment } from '../utils/utils';
const DEFAULT_NUM_SECONDS_TO_WAIT = 5;
// make the timer go faster on localhost, but count the same number of "seconds":
const TIMEOUT_DELAY_MS = isLocalhostEnvironment() ? 200 : 1000;
export const TimeDelayButton = ({ disabledLabel, enabledLabel, ariaLabel, variant, color, numSeconds = DEFAULT_NUM_SECONDS_TO_WAIT, onClick }) => {
    const [numSecondsRemaining, setNumSecondsRemaining] = useState(numSeconds);
    const isMounted = useMountedState();
    const decreaseSecondsRemaining = useCallback(() => {
        if (!isMounted()) {
            return;
        }
        setNumSecondsRemaining((currNumSecondsRemaining) => Math.max(currNumSecondsRemaining - 1, 0));
    }, [isMounted]);
    useEffect(() => {
        if (numSecondsRemaining === 0) {
            return;
        }
        setTimeout(decreaseSecondsRemaining, TIMEOUT_DELAY_MS);
    }, [numSecondsRemaining, decreaseSecondsRemaining]);
    const isDisabled = numSecondsRemaining > 0;
    const label = isDisabled ? `${disabledLabel} ...${numSecondsRemaining}` : enabledLabel;
    return (_jsx(Button, { "aria-label": ariaLabel, variant: variant, color: color, onClick: onClick, disabled: isDisabled, children: label }));
};
